<div class="w-100 border rounded m-0 p-0 p-3">
  <ng-template *ngIf="loading; then loadingTrue else loadingFalse"></ng-template>
  <ng-template #loadingTrue>
    <div class="d-flex justify-content-center align-items-center" style="height: 96px;">
      <mat-spinner strokeWidth="2" color="primary" diameter="40"></mat-spinner>
    </div>
  </ng-template>
  <ng-template #loadingFalse>
    <ng-template *ngIf="isError; then isErrorTrue else isErrorFalse"></ng-template>
    <ng-template #isErrorTrue>
      <div class="d-flex flex-column justify-content-center align-items-center gap-3" style="height: 96px;">
        <div>{{error?.message}}</div>
        <button class="mx-auto" mat-stroked-button color="primary" (click)="postTechMessage()">
          Invia comunicazione
        </button>
      </div>
    </ng-template>
    <ng-template #isErrorFalse>
      <div class="row m-0 p-0">
        <div class="col m-0 p-0">
          <div class="hstack m-0 p-0">
            <button class="ms-auto" mat-stroked-button color="primary" (click)="postTechMessage()">
              Invia comunicazione
            </button>
          </div>
          <div class="row m-0 mt-3 p-0 opacity-50" *ngIf=" loading==false && isError==false && techMessages.length==0">
            Nessuna comunicazione inviata.
          </div>
          <div class="row m-0 mt-3 p-0" *ngFor="let techMessage of techMessages;">
            <div class="col m-0 p-0">
              {{techMessage.createdAt | toItDateDdMmmmYyyy}}
            </div>
            <div class="col" style="font-size: 0.65rem;">
              {{techMessage.emails.join(', ')}}
            </div>
            <div class="col">
              <div *ngIf="techMessage.price">Prezzo: {{techMessage.price}}€</div>
            </div>
            <div class="col m-0 p-0">
              <a *ngIf="techMessage.stripeLink" href="{{techMessage.stripeLink}}" target="_blank">Link</a>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-template>
</div>
